import { PlusOutlined, SearchOutlined, UploadOutlined, CaretDownFilled, DeleteFilled, SaveOutlined,StarFilled,StarOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, InputNumber, Row, Select, Space, Typography, Divider, DatePicker, Table, Tooltip } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../../routes";

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;

const TableNameListView = (props) => {
    const navigate = useNavigate();
    const { dataDetail } = props;

    const columns = [
        {
            title: "ลำดับ",
            align: "center",
            dataIndex: "sequence",
            key: "sequence",
            width: 72,
        },
        {
            title: "ชื่อ-นามสกุล",
            align: "center",
            dataIndex: "name",
            key: "name",
            width: 72,
        },
        {
            title: "ตำแหน่ง",
            align: "center",
            dataIndex: "position",
            key: "position",
            width: 72,
        },
        {
            title: "เบอร์โทรศัพท์ผู้ติดต่อ",
            align: "center",
            dataIndex: "phones",
            key: "phones",
            width: 72,
        },
        {
            title: "Email ผู้ติดต่อ",
            align: "center",
            dataIndex: "emails",
            key: "emails",
            width: 72,
        },
        {
            title: " Action",
            align: "center",
            dataIndex : "favorite",
            key : "favorite",
            width : 72,
            render: (_, record) => {
                 const isFavorite = record.favorite === true;
                return(<Button
                    shape="circle"
                    icon={
                    isFavorite ? (
                        <StarFilled style={{ color: "#F79009" }} />
                    ) : (
                        <StarOutlined style={{ color: "#F79009" }} />
                    )
                    }
                    style={
                    isFavorite
                        ? { backgroundColor: "#FEF1DF", border: "none" } // favorite = ดาวทึบ พื้นเหลือง
                        : { backgroundColor: "#FFFFFF", borderColor: "#F79009" } // ไม่ favorite = ขอบเหลือง พื้นขาว
                    }
                />)
            }
        }
    ];

    return (
        <Content>
            <Form.Item label={<Text className="pr_green">รายชื่อ</Text>}>
                <Text>
                    จำนวนรายชื่อทั้งหมด
                    <Text strong color="#6442a4">
                        &nbsp;{dataDetail? dataDetail.length : 0}&nbsp;
                    </Text>
                    คน
                </Text>

                <Table style={{ padding: "30px 0px 30px 0px" }} dataSource={dataDetail} columns={columns} pagination={false}></Table>
            </Form.Item>
        </Content>
    );
};

export default TableNameListView;
